import React from "react";

const BookingFooter = () => {
  const year = new Date()?.getFullYear();
  return (
    <footer className="booking-footer">
      <p style={{ fontSize: '12px', color: '#6b7a8d', fontFamily: 'var(--font-ui)', lineHeight: 1.6 }}>
        &copy; {year} ZBA – Zentrale Brandschutztechnik-Akademie GmbH
        <span style={{ margin: '0 8px', opacity: 0.4 }}>·</span>
        <a href="https://zba.academy/impressum" target="_blank" rel="noopener noreferrer">Impressum</a>
        <span style={{ margin: '0 8px', opacity: 0.4 }}>·</span>
        <a href="https://zba.academy/datenschutz" target="_blank" rel="noopener noreferrer">Datenschutz</a>
      </p>
    </footer>
  );
};

export default BookingFooter;